export const MQTT_REQUEST = '@api/MQTT_REQUEST'
export const MQTT_SUCCESS = '@api/MQTT_SUCCESS'
export const MQTT_ERROR = '@api/MQTT_ERROR'

export const MQTT_CLEAN_SUCCESS_REQUEST = '@api/MQTT_CLEAN_SUCCESS_REQUEST'
export const MQTT_CLEAN_ERROR_REQUEST = '@api/MQTT_CLEAN_ERROR_REQUEST'
